module.exports = __webpack_public_path__ + "media/images/advisor/img_3_2-8382a0532a74105cf2cb6882544a940b.png";